export const FALLBACK_CURRENCY = "GHS";

export const numberOr = (value, fallback = null) => {
  if (value === null || value === undefined || value === "") return fallback;

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
};

export const mapMoney = (money) => {
  const value = numberOr(money?.value);

  if (value === null) return null;

  return { value, currency: money?.currency || FALLBACK_CURRENCY };
};

export const sumMoney = (moneys) => {
  const parts = (moneys || []).filter(Boolean);

  if (!parts.length) return null;

  return {
    value: parts.reduce((sum, money) => sum + money.value, 0),
    currency: parts[0].currency,
  };
};
